export const setPreviousPath = () => {
  console.log(window.location.pathname);

  const prevPath =
    window.location.pathname + window.location.search + window.location.hash;
  window.sessionStorage.setItem("bVpreviousPathStorageKey", prevPath);
};
